import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

export const PaymentFailureBanner: React.FC = () => {
  const { stripeSubscriptionStatus } = useAuth();

  const isActive = stripeSubscriptionStatus === 'past_due';

  return (
    <div
      className={`grid transition-[grid-template-rows] duration-300 ease-in-out ${
        isActive ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
      }`}
    >
      <div className="overflow-hidden">
        <div className="bg-destructive/10 border-b border-destructive/20 px-4 py-2.5 text-center text-sm">
          <div className="flex items-center justify-center gap-2 text-destructive">
            <AlertTriangle className="h-4 w-4 shrink-0" />
            <span>
              Your payment failed. Update your payment method to avoid losing premium access.
            </span>
            <Link
              to="/account?tab=billing"
              className="ml-1 font-medium underline underline-offset-2 hover:text-destructive/80"
            >
              Go to billing
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
